const PROFNASTIL_ADVANTAGE_LIST: string[] = [
  'Защищают от\u00A0пыли и\u00A0шума',
  'Легко монтируются благодаря \nнебольшому весу',
  'Подходят для установки на\u00A0участке \nс\u00A0любым ландшафтом',
];

const SHTAKETNIK_ADVANTAGE_LIST: string[] = [
  'Привлекательный внешний вид, как у\u00A0классического деревянного ограждения',
  'Не\u00A0подвергается воздействию ветра, при\u00A0этом продувается',
  'Возможны различные варианты монтажа: в\u00A0один ряд, в\u00A0два или горизонтально',
  'Удобен в\u00A0перевозке и\u00A0хранении, поставляется сложенным в\u00A0стопки',
  'Можно установить самостоятельно без специального оборудования',
];

const MODULNYE_OGRAZHDENIYA_ADVANTAGE_LIST: string[] = [
  'Все элементы ограждений оцинкованы и\u00A0не\u00A0требуют обслуживания',
  'Монтируются модулями, без помощи сварочного оборудования',
];

const PANELNYE_OGRAZHDENIYA_ADVANTAGE_LIST: string[] = [
  'Широкий размерный ряд',
  'Не\u00A0требуют регулярной покраски после установки',
  'Не\u00A0нужна сварка при сборке',
  'Комплектуются антивандальными креплениями',
];

const ZHALYUZI_OGRAZHDENIYA_ADVANTAGE_LIST: string[] = [
  'Устойчивы к\u00A0ветру, пропускают воздух и\u00A0свет',
  'Монтируются без сварки',
  'Доступны двусторонние покрытия или обратная сторона в\u00A0тон лицевого покрытия',
  'Удобны в\u00A0перевозке',
];

export const FENCES_ADVANTAGES_MAP: Record<string, string[]> = {
  'zabory-iz-profnastila': PROFNASTIL_ADVANTAGE_LIST,
  'metallicheskiy-shtaketnik': SHTAKETNIK_ADVANTAGE_LIST,
  'modulnye-ograzhdeniya': MODULNYE_OGRAZHDENIYA_ADVANTAGE_LIST,
  'panelnye-ograzhdeniya': PANELNYE_OGRAZHDENIYA_ADVANTAGE_LIST,
  'zabory-zhalyuzi': ZHALYUZI_OGRAZHDENIYA_ADVANTAGE_LIST,
};
